import {
  Button,
  Card,
  CardContent,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField
} from "@material-ui/core";
import CardSpacer from "@saleor/components/CardSpacer";
import Container from "@saleor/components/Container";
import Grid from "@saleor/components/Grid";
import PageHeader from "@saleor/components/PageHeader";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import { sectionNames } from "@saleor/intl";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { OrderErpStatusNote_orderErpStatusNote } from "../types/OrderErpStatusNote";

export interface ErpStatusNotePageProps {
  erpStatusNotes: OrderErpStatusNote_orderErpStatusNote[];
  createDefault: () => void;
  updateNote: (status: string, note: string) => void;
  disabled: boolean;
}

const ErpStatusNotePage: React.FC<ErpStatusNotePageProps> = ({
  erpStatusNotes,
  createDefault,
  updateNote,
  disabled
}) => {
  const intl = useIntl();
  // eslint-disable-next-line no-console
  // console.log(erpStatusNotes);
  const haveDefaultDate = erpStatusNotes?.length === 0 ? false : true;
  return (
    <>
      <Container>
        <PageHeader title={intl.formatMessage(sectionNames.erpstatusnote)} />
        <Grid>
          {haveDefaultDate && erpStatusNotes ? (
            <Card>
              <CardContent>
                <ResponsiveTable>
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <FormattedMessage defaultMessage="Status" />
                      </TableCell>
                      <TableCell colSpan={3}>
                        <FormattedMessage defaultMessage="Note" />
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {erpStatusNotes?.map(erpStatusNote => {
                      const [isEdit, setIsEdit] = React.useState<boolean>(
                        false
                      );
                      const [noteText, setNoteText] = React.useState<string>(
                        erpStatusNote.note
                      );
                      return (
                        <>
                          <TableRow>
                            <TableCell>
                              {erpStatusNote ? (
                                erpStatusNote.status
                              ) : (
                                <Skeleton />
                              )}
                            </TableCell>
                            {isEdit ? (
                              <TableCell colSpan={2}>
                                <TextField
                                  disabled={disabled}
                                  label={intl.formatMessage({
                                    defaultMessage: "Note",
                                    description: "Note"
                                  })}
                                  fullWidth
                                  value={noteText}
                                  multiline={true}
                                  onChange={event =>
                                    setNoteText(event?.target?.value)
                                  }
                                />
                              </TableCell>
                            ) : (
                              <TableCell colSpan={2}>
                                {erpStatusNote ? (
                                  erpStatusNote.note
                                ) : (
                                  <Skeleton />
                                )}
                              </TableCell>
                            )}
                            <TableCell style={{ textAlign: "right" }}>
                              {isEdit ? (
                                <>
                                  <Button
                                    color="primary"
                                    onClick={() => {
                                      setIsEdit(false);
                                      updateNote(
                                        erpStatusNote.status,
                                        noteText
                                      );
                                    }}
                                  >
                                    Save
                                  </Button>
                                  <Button
                                    color="primary"
                                    onClick={() => {
                                      setIsEdit(false);
                                      setNoteText(erpStatusNote.note);
                                    }}
                                  >
                                    Back
                                  </Button>
                                </>
                              ) : (
                                <Button
                                  color="primary"
                                  onClick={() => setIsEdit(true)}
                                >
                                  Edit
                                </Button>
                              )}
                            </TableCell>
                          </TableRow>
                        </>
                      );
                    })}
                  </TableBody>
                </ResponsiveTable>
              </CardContent>
            </Card>
          ) : (
            <>
              <Card>
                <CardContent>
                  <Button
                    color="primary"
                    onClick={createDefault}
                    disabled={disabled}
                  >
                    <FormattedMessage
                      defaultMessage="Create Default"
                      description="button"
                    />
                  </Button>

                  <CardSpacer />
                  <p style={{ color: "#999", marginLeft: "20px" }}>
                    {
                      "The current site has not set Erp Status Note, please initialize first"
                    }
                  </p>
                </CardContent>
              </Card>
            </>
          )}
        </Grid>
      </Container>
    </>
  );
};
export default ErpStatusNotePage;
